import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NewsletterSignup = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
      toast.success('Successfully subscribed to newsletter!');
      setEmail('');
    } catch (error) {
      const message = error.response?.data?.detail || 'Failed to subscribe. Please try again.';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white border border-slate-200 rounded shadow-sm p-8" data-testid="newsletter-signup">
      <h3 className="font-heading font-medium text-2xl text-brand-primary mb-3">
        Stay Connected
      </h3>
      <p className="font-body text-base text-slate-700 mb-6">
        Subscribe to receive updates on new resources and teachings.
      </p>
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your email address"
          required
          className="flex-1 px-4 py-3 border border-slate-200 rounded focus:border-brand-accent focus:ring-2 focus:ring-brand-accent/20 outline-none font-body text-sm"
          data-testid="newsletter-email-input"
        />
        <button
          type="submit"
          disabled={loading}
          className="px-6 py-3 bg-brand-accent text-white font-body font-medium rounded hover:bg-brand-accent-hover transition-all duration-300 disabled:opacity-50"
          data-testid="newsletter-submit-button"
        >
          {loading ? 'Subscribing...' : 'Subscribe'}
        </button>
      </form>
    </div>
  );
};

export default NewsletterSignup;